
import { call, put, takeEvery } from 'redux-saga/effects'

import { createActionTypes } from '../../common/client/sagas/common';
import { ERROR_CLEAR_ACTION_TYPE, ERROR_CREATE_ACTION_TYPE } from '../../common/client/sagas/operationStatus';
import server from '../server';

import { SELECT_REPORT } from './ui';

export const GET_DEFINITION_ACTION_TYPE = createActionTypes('print/GET_DEFINITION');

export default function getActions(dispatch) {
    return {
        getDefinition: (projectId, debug) => dispatch({
            type: GET_DEFINITION_ACTION_TYPE.DEFAULT,
            projectId,
            debug
        })
    };
}

function getDefinition(action) {
    return new Promise((resolve, reject) => {
        server.print.getDefinition(
            action.projectId, action.debug,
            (err, definition) => {
                if (definition) {
                    resolve(definition);
                } else {
                    reject(err);
                }
            }
        );
    });
}

function* workGetDefinition(action) {
    try {
        yield put({type: ERROR_CLEAR_ACTION_TYPE});
        yield put({type: GET_DEFINITION_ACTION_TYPE.LOADING});
        let reportDefinition = yield call(getDefinition, action);
        reportDefinition = [
            {
                id: '__INTERNAL__',
                title: 'Tisk mapových oken',
                type: 'INTERNAL'
            },
            ...reportDefinition
        ];

        if (reportDefinition.length > 0) {
            yield put({
                type: SELECT_REPORT,
                reportId: reportDefinition[0].id,
                reportType: reportDefinition[0].type
            });
        }

        yield put({type: GET_DEFINITION_ACTION_TYPE.SUCCESS, reportDefinition: reportDefinition});
    } catch (error) {
        yield put({type: GET_DEFINITION_ACTION_TYPE.FAILED, error});
        yield put({type: ERROR_CREATE_ACTION_TYPE, error});
    }
}

export function* watchGetDefinition() {
    yield takeEvery(GET_DEFINITION_ACTION_TYPE.DEFAULT, workGetDefinition);
}
